import { isParent } from '@repo/lib/user-lvl/isParent';
import { Navigate } from 'react-router';

import HomePage from '@/pages/_main/home/HomePage';
import { useCredentials } from '@/store/auth-store';

/**
 * The landing route.
 *
 * Parents have their own environment, and none of the home feed's posts,
 * groups or assignments are addressed to them, so they are sent to `/parent`
 * instead. Everyone else gets the usual home page.
 */
export function HomeEntry() {
  const { accountType } = useCredentials();

  if (isParent(accountType)) {
    return <Navigate to={'/parent'} replace />;
  }

  return <HomePage />;
}
